import {createContext, useContext} from 'react';

import RackEditorStore from '../store/RackEditorStore';

const RackEditorStoreContext = createContext<RackEditorStore>(new RackEditorStore());

export const RackEditorStoreProvider = RackEditorStoreContext.Provider;
export const useRackEditorStore = () => useContext(RackEditorStoreContext);
